
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import CookiePolicy from './CookiePolicy';
import { useLocale } from '../../localization/LocaleContext';

function CookiePolicyMain() {
    const { t } = useLocale();
    useEffect(() => {
        document.title = t('meta.cookiePolicyTitle')
   }, [t]);
   const[loader, SetLoader] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        },1500)

        return () => clearTimeout(timer)
    }, [])
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <CookiePolicy/>
            <Footer/>
        </Fragment>
    )
    
}

export default CookiePolicyMain;